import React from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { selectLocalOfferIds, useRemoveOfferFromComparisonMutation } from "@entities/compare";
import { removeLocalOffer } from "@entities/compare/model/compareSlice";
import { DeleteIcon } from "@shared/ui/Icon/ui/Common/DeleteIcon";
import { DeleteCompareOfferProps } from "./types";
import classes from "./DeleteCompareOffer.module.scss";

export const DeleteCompareOffer = ({
    offerId,
    className,
    classNameIcon
}: DeleteCompareOfferProps) => {
    const [removeOfferFromComparison, { isLoading }] = useRemoveOfferFromComparisonMutation();
    const dispatch = useDispatch();
    const localOfferIds = useSelector(selectLocalOfferIds);

    const handleDelete = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();

        if (localOfferIds.includes(offerId)) {
            dispatch(removeLocalOffer(offerId));
            return;
        }

        await removeOfferFromComparison({ offerId }).unwrap();
    };

    return (
        <button onClick={handleDelete} disabled={isLoading} className={className}>
            <DeleteIcon
                className={classNames({
                    [classes["delete-compare"]]: !classNameIcon,
                    [classNameIcon!]: classNameIcon
                })}
            />
        </button>
    );
};